import { useTranslation } from "react-i18next";
import { Button } from "@/components/Button";
import SmilingWoman from "@/assets/Img/smiling-woman.jpg";
import CreateAccountEn from "@/assets/Img/HowItWorks/create-your-account-en.png";
import CreateAccountEs from "@/assets/Img/HowItWorks/create-your-account-es.png";
import PaymentMethodEn from "@/assets/Img/HowItWorks/payment-method-en.png";
import PaymentMethodEs from "@/assets/Img/HowItWorks/payment-method-es.png";
import AddRecipientEn from "@/assets/Img/HowItWorks/add-recipient-en.png";
import AddRecipientEs from "@/assets/Img/HowItWorks/add-recipient-es.png";
import StepSection from "@/components/StepSection";

export default function HowItWorksPage() {
  const { t, i18n } = useTranslation("global");
  const isEs = i18n.language === "es";

  return (
    <div className="w-full flex flex-col">
      <div className="relative w-full h-72 md:h-[32rem] lg:h-[40rem]">
        <img
          className="w-full h-full absolute top-0 left-0 object-cover object-top"
          src={SmilingWoman}
          alt="Smiling woman using phone"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center">
          <h1 className="text-4xl lg:text-6xl 2xl:text-7xl text-white font-semibold lg:-translate-y-10">
            {t("HowItWorks.Heading")}
          </h1>
        </div>
      </div>
      <StepSection
        step={1}
        title={t("HowItWorks.Steps.Step1.Title")}
        paragraph={t("HowItWorks.Steps.Step1.Paragraph")}
        image={isEs ? CreateAccountEs : CreateAccountEn}
        variant="purple"
        className="rounded-t-3xl -mt-8 pt-16"
      />
      <StepSection
        step={2}
        title={t("HowItWorks.Steps.Step2.Title")}
        paragraph={t("HowItWorks.Steps.Step2.Paragraph")}
        variant="white"
      />
      <StepSection
        step={3}
        title={t("HowItWorks.Steps.Step3.Title")}
        paragraph={t("HowItWorks.Steps.Step3.Paragraph")}
        image={isEs ? PaymentMethodEs : PaymentMethodEn}
        variant="white"
      />
      <StepSection
        step={4}
        title={t("HowItWorks.Steps.Step4.Title")}
        paragraph={t("HowItWorks.Steps.Step4.Paragraph")}
        variant="gray"
      />
      <StepSection
        step={5}
        title={t("HowItWorks.Steps.Step5.Title")}
        paragraph={t("HowItWorks.Steps.Step5.Paragraph")}
        image={isEs ? AddRecipientEs : AddRecipientEn}
        variant="gray"
        className="pb-8"
      />

      {/* CTA banner */}
      <div className="relative z-0 w-full bg-[#3d73f2] py-32 px-6 flex flex-col items-center gap-8">
        <p className="text-white text-2xl md:text-3xl font-semibold text-center">
          {t("HowItWorks.CTA.Title")}
        </p>
        <Button
          text={t("HowItWorks.CTA.Button")}
          link="/"
          size="lg"
          className="!bg-white !border-white !text-black hover:!opacity-90"
        />
      </div>
    </div>
  );
}
